var _style, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 900",
    style: {
      enableBackground: "new 0 0 1440 900"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);fill-opacity:0.95;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1440,
    height: 900
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 720,
    y1: 902,
    x2: 720,
    y2: 2,
    gradientTransform: "matrix(1 0 0 -1 0 902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104167,
    style: {
      stopColor: "#FFB31F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2396,
    style: {
      stopColor: "#FFB31F",
      stopOpacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#FFB31F",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6979,
    style: {
      stopColor: "#FFB31F",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB31F",
      stopOpacity: 0.31
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1440,
    height: 900
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeBg3);
export default __webpack_public_path__ + "static/media/practice-bg3.8cb2f3198f499fd3489d800dbc5ad670.svg";
export { ForwardRef as ReactComponent };